// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductFAQ_wrapper__MiIgC"};